import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const reduxInitialized = createAction(
  `${reduxKey}.REDUX_INITIALIZED`,
  () => ({})
);

export const reduxInitializationFailed = createAction(
  `${reduxKey}.REDUX_INITIALIZATION_FAILED`,
  () => ({})
);

/**
 * Before we mount NC components that use our dynamically loaded translations, we have to make sure our translation backend
 * is prepared to load them in.
 */
export const translationsPreparedForImport = createAction(
  `${reduxKey}.TRANSLATIONS_PREPARED_FOR_IMPORT`,
  () => ({})
);

/**
 * Translations were unable to be imported. We should probably show some error UI.
 */
export const translationsImportFailed = createAction(
  `${reduxKey}.TRANSLATIONS_IMPORT_FAILED`,
  () => ({})
);

export const damzOnline = createAction(`${reduxKey}.DAMZ_ONLINE`, () => ({}));
export const damzOffline = createAction(`${reduxKey}.DAMZ_OFFLINE`, error => ({
  error,
}));
